import VueFullscreen from "vue-fullscreen";
import Vue from "vue";

Vue.use(VueFullscreen);
